/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_tracing_tracing_pb = require('../../../../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/v1/options/tracing/tracing_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_protocol_upgrade_protocol_upgrade_pb = require('../../../../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/v1/options/protocol_upgrade/protocol_upgrade_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_protocol_protocol_pb = require('../../../../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/v1/options/protocol/protocol_pb.js');
var extproto_ext_pb = require('../../../../../../../../../extproto/ext_pb.js');
goog.exportSymbol('proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings', null, global);
goog.exportSymbol('proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange', null, global);
goog.exportSymbol('proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CodecType', null, global);
goog.exportSymbol('proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.ForwardClientCertDetails', null, global);
goog.exportSymbol('proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.HeadersWithUnderscoreAction', null, global);
goog.exportSymbol('proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig', null, global);
goog.exportSymbol('proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.PathWithEscapedSlashesAction', null, global);
goog.exportSymbol('proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.ServerHeaderTransformation', null, global);
goog.exportSymbol('proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails', null, global);
goog.exportSymbol('proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.repeatedFields_, proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.oneofGroups_);
};
goog.inherits(proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.displayName = 'proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.repeatedFields_ = [21];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.oneofGroups_ = [[22,31]];

/**
 * @enum {number}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.HeaderFormatCase = {
  HEADER_FORMAT_NOT_SET: 0,
  PROPER_CASE_HEADER_KEY_FORMAT: 22,
  PRESERVE_CASE_HEADER_KEY_FORMAT: 31
};

/**
 * @return {proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.HeaderFormatCase}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getHeaderFormatCase = function() {
  return /** @type {proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.HeaderFormatCase} */(jspb.Message.computeOneofCase(this, proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    skipXffAppend: (f = msg.getSkipXffAppend()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    via: (f = msg.getVia()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    xffNumTrustedHops: (f = msg.getXffNumTrustedHops()) && google_protobuf_wrappers_pb.UInt32Value.toObject(includeInstance, f),
    useRemoteAddress: (f = msg.getUseRemoteAddress()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    generateRequestId: (f = msg.getGenerateRequestId()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    proxy100Continue: (f = msg.getProxy100Continue()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    streamIdleTimeout: (f = msg.getStreamIdleTimeout()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    idleTimeout: (f = msg.getIdleTimeout()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    maxRequestHeadersKb: (f = msg.getMaxRequestHeadersKb()) && google_protobuf_wrappers_pb.UInt32Value.toObject(includeInstance, f),
    requestTimeout: (f = msg.getRequestTimeout()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    requestHeadersTimeout: (f = msg.getRequestHeadersTimeout()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    drainTimeout: (f = msg.getDrainTimeout()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    delayedCloseTimeout: (f = msg.getDelayedCloseTimeout()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    serverName: (f = msg.getServerName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    stripAnyHostPort: (f = msg.getStripAnyHostPort()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    acceptHttp10: (f = msg.getAcceptHttp10()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    defaultHostForHttp10: (f = msg.getDefaultHostForHttp10()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    allowChunkedLength: (f = msg.getAllowChunkedLength()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    enableTrailers: (f = msg.getEnableTrailers()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    properCaseHeaderKeyFormat: (f = msg.getProperCaseHeaderKeyFormat()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    preserveCaseHeaderKeyFormat: (f = msg.getPreserveCaseHeaderKeyFormat()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    tracing: (f = msg.getTracing()) && github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_tracing_tracing_pb.ListenerTracingSettings.toObject(includeInstance, f),
    forwardClientCertDetails: jspb.Message.getFieldWithDefault(msg, 18, 0),
    setCurrentClientCertDetails: (f = msg.getSetCurrentClientCertDetails()) && proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.toObject(includeInstance, f),
    preserveExternalRequestId: (f = msg.getPreserveExternalRequestId()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    upgradesList: jspb.Message.toObjectList(msg.getUpgradesList(),
    github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_protocol_upgrade_protocol_upgrade_pb.ProtocolUpgradeConfig.toObject, includeInstance),
    maxConnectionDuration: (f = msg.getMaxConnectionDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    maxStreamDuration: (f = msg.getMaxStreamDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    maxHeadersCount: (f = msg.getMaxHeadersCount()) && google_protobuf_wrappers_pb.UInt32Value.toObject(includeInstance, f),
    headersWithUnderscoresAction: jspb.Message.getFieldWithDefault(msg, 32, 0),
    maxRequestsPerConnection: (f = msg.getMaxRequestsPerConnection()) && google_protobuf_wrappers_pb.UInt32Value.toObject(includeInstance, f),
    serverHeaderTransformation: jspb.Message.getFieldWithDefault(msg, 25, 0),
    pathWithEscapedSlashesAction: jspb.Message.getFieldWithDefault(msg, 26, 0),
    codecType: jspb.Message.getFieldWithDefault(msg, 28, 0),
    mergeSlashes: (f = msg.getMergeSlashes()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    normalizePath: (f = msg.getNormalizePath()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    uuidRequestIdConfig: (f = msg.getUuidRequestIdConfig()) && proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.toObject(includeInstance, f),
    http2ProtocolOptions: (f = msg.getHttp2ProtocolOptions()) && github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_protocol_protocol_pb.Http2ProtocolOptions.toObject(includeInstance, f),
    internalAddressConfig: (f = msg.getInternalAddressConfig()) && proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.toObject(includeInstance, f),
    appendXForwardedPort: (f = msg.getAppendXForwardedPort()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings;
  return proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSkipXffAppend(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setVia(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.UInt32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.UInt32Value.deserializeBinaryFromReader);
      msg.setXffNumTrustedHops(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setUseRemoteAddress(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setGenerateRequestId(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setProxy100Continue(value);
      break;
    case 7:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setStreamIdleTimeout(value);
      break;
    case 8:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setIdleTimeout(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.UInt32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.UInt32Value.deserializeBinaryFromReader);
      msg.setMaxRequestHeadersKb(value);
      break;
    case 10:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setRequestTimeout(value);
      break;
    case 11:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setRequestHeadersTimeout(value);
      break;
    case 12:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDrainTimeout(value);
      break;
    case 13:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDelayedCloseTimeout(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setServerName(value);
      break;
    case 36:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setStripAnyHostPort(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setAcceptHttp10(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDefaultHostForHttp10(value);
      break;
    case 34:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setAllowChunkedLength(value);
      break;
    case 35:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnableTrailers(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setProperCaseHeaderKeyFormat(value);
      break;
    case 31:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setPreserveCaseHeaderKeyFormat(value);
      break;
    case 17:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_tracing_tracing_pb.ListenerTracingSettings;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_tracing_tracing_pb.ListenerTracingSettings.deserializeBinaryFromReader);
      msg.setTracing(value);
      break;
    case 18:
      var value = /** @type {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.ForwardClientCertDetails} */ (reader.readEnum());
      msg.setForwardClientCertDetails(value);
      break;
    case 19:
      var value = new proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails;
      reader.readMessage(value,proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.deserializeBinaryFromReader);
      msg.setSetCurrentClientCertDetails(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setPreserveExternalRequestId(value);
      break;
    case 21:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_protocol_upgrade_protocol_upgrade_pb.ProtocolUpgradeConfig;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_protocol_upgrade_protocol_upgrade_pb.ProtocolUpgradeConfig.deserializeBinaryFromReader);
      msg.addUpgrades(value);
      break;
    case 23:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setMaxConnectionDuration(value);
      break;
    case 24:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setMaxStreamDuration(value);
      break;
    case 27:
      var value = new google_protobuf_wrappers_pb.UInt32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.UInt32Value.deserializeBinaryFromReader);
      msg.setMaxHeadersCount(value);
      break;
    case 32:
      var value = /** @type {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.HeadersWithUnderscoreAction} */ (reader.readEnum());
      msg.setHeadersWithUnderscoresAction(value);
      break;
    case 33:
      var value = new google_protobuf_wrappers_pb.UInt32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.UInt32Value.deserializeBinaryFromReader);
      msg.setMaxRequestsPerConnection(value);
      break;
    case 25:
      var value = /** @type {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.ServerHeaderTransformation} */ (reader.readEnum());
      msg.setServerHeaderTransformation(value);
      break;
    case 26:
      var value = /** @type {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.PathWithEscapedSlashesAction} */ (reader.readEnum());
      msg.setPathWithEscapedSlashesAction(value);
      break;
    case 28:
      var value = /** @type {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CodecType} */ (reader.readEnum());
      msg.setCodecType(value);
      break;
    case 29:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setMergeSlashes(value);
      break;
    case 30:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setNormalizePath(value);
      break;
    case 37:
      var value = new proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings;
      reader.readMessage(value,proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.deserializeBinaryFromReader);
      msg.setUuidRequestIdConfig(value);
      break;
    case 39:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_protocol_protocol_pb.Http2ProtocolOptions;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_protocol_protocol_pb.Http2ProtocolOptions.deserializeBinaryFromReader);
      msg.setHttp2ProtocolOptions(value);
      break;
    case 38:
      var value = new proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig;
      reader.readMessage(value,proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.deserializeBinaryFromReader);
      msg.setInternalAddressConfig(value);
      break;
    case 40:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setAppendXForwardedPort(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSkipXffAppend();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getVia();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getXffNumTrustedHops();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.UInt32Value.serializeBinaryToWriter
    );
  }
  f = message.getUseRemoteAddress();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getGenerateRequestId();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getProxy100Continue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStreamIdleTimeout();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getIdleTimeout();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getMaxRequestHeadersKb();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.UInt32Value.serializeBinaryToWriter
    );
  }
  f = message.getRequestTimeout();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getRequestHeadersTimeout();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getDrainTimeout();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getDelayedCloseTimeout();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getServerName();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStripAnyHostPort();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getAcceptHttp10();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getDefaultHostForHttp10();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAllowChunkedLength();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getEnableTrailers();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getProperCaseHeaderKeyFormat();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getPreserveCaseHeaderKeyFormat();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getTracing();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_tracing_tracing_pb.ListenerTracingSettings.serializeBinaryToWriter
    );
  }
  f = message.getForwardClientCertDetails();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getSetCurrentClientCertDetails();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.serializeBinaryToWriter
    );
  }
  f = message.getPreserveExternalRequestId();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getUpgradesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_protocol_upgrade_protocol_upgrade_pb.ProtocolUpgradeConfig.serializeBinaryToWriter
    );
  }
  f = message.getMaxConnectionDuration();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getMaxStreamDuration();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getMaxHeadersCount();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_wrappers_pb.UInt32Value.serializeBinaryToWriter
    );
  }
  f = message.getHeadersWithUnderscoresAction();
  if (f !== 0.0) {
    writer.writeEnum(
      32,
      f
    );
  }
  f = message.getMaxRequestsPerConnection();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      google_protobuf_wrappers_pb.UInt32Value.serializeBinaryToWriter
    );
  }
  f = message.getServerHeaderTransformation();
  if (f !== 0.0) {
    writer.writeEnum(
      25,
      f
    );
  }
  f = message.getPathWithEscapedSlashesAction();
  if (f !== 0.0) {
    writer.writeEnum(
      26,
      f
    );
  }
  f = message.getCodecType();
  if (f !== 0.0) {
    writer.writeEnum(
      28,
      f
    );
  }
  f = message.getMergeSlashes();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getNormalizePath();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getUuidRequestIdConfig();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.serializeBinaryToWriter
    );
  }
  f = message.getHttp2ProtocolOptions();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_protocol_protocol_pb.Http2ProtocolOptions.serializeBinaryToWriter
    );
  }
  f = message.getInternalAddressConfig();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.serializeBinaryToWriter
    );
  }
  f = message.getAppendXForwardedPort();
  if (f != null) {
    writer.writeMessage(
      40,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.ForwardClientCertDetails = {
  SANITIZE: 0,
  FORWARD_ONLY: 1,
  APPEND_FORWARD: 2,
  SANITIZE_SET: 3,
  ALWAYS_FORWARD_ONLY: 4
};

/**
 * @enum {number}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.ServerHeaderTransformation = {
  OVERWRITE: 0,
  APPEND_IF_ABSENT: 1,
  PASS_THROUGH: 2
};

/**
 * @enum {number}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.HeadersWithUnderscoreAction = {
  ALLOW: 0,
  REJECT_CLIENT_REQUEST: 1,
  DROP_HEADER: 2
};

/**
 * @enum {number}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.PathWithEscapedSlashesAction = {
  IMPLEMENTATION_SPECIFIC_DEFAULT: 0,
  KEEP_UNCHANGED: 1,
  REJECT_REQUEST: 2,
  UNESCAPE_AND_REDIRECT: 3,
  UNESCAPE_AND_FORWARD: 4
};

/**
 * @enum {number}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CodecType = {
  AUTO: 0,
  HTTP1: 1,
  HTTP2: 2
};


/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.displayName = 'proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    subject: (f = msg.getSubject()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    cert: (f = msg.getCert()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    chain: (f = msg.getChain()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    dns: (f = msg.getDns()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    uri: (f = msg.getUri()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails;
  return proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSubject(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCert(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setChain(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setDns(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setUri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubject();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCert();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getChain();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getDns();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getUri();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.BoolValue subject = 1;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.getSubject = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 1));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.setSubject = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.clearSubject = function() {
  this.setSubject(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.hasSubject = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.BoolValue cert = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.getCert = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.setCert = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.clearCert = function() {
  this.setCert(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.hasCert = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue chain = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.getChain = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.setChain = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.clearChain = function() {
  this.setChain(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.hasChain = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue dns = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.getDns = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.setDns = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.clearDns = function() {
  this.setDns(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.hasDns = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue uri = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.getUri = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.setUri = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.clearUri = function() {
  this.setUri(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails.prototype.hasUri = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.displayName = 'proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    packTraceReason: (f = msg.getPackTraceReason()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    useRequestIdForTraceSampling: (f = msg.getUseRequestIdForTraceSampling()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings;
  return proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setPackTraceReason(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setUseRequestIdForTraceSampling(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackTraceReason();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getUseRequestIdForTraceSampling();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.BoolValue pack_trace_reason = 1;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.prototype.getPackTraceReason = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 1));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.prototype.setPackTraceReason = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.prototype.clearPackTraceReason = function() {
  this.setPackTraceReason(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.prototype.hasPackTraceReason = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.BoolValue use_request_id_for_trace_sampling = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.prototype.getUseRequestIdForTraceSampling = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.prototype.setUseRequestIdForTraceSampling = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.prototype.clearUseRequestIdForTraceSampling = function() {
  this.setUseRequestIdForTraceSampling(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings.prototype.hasUseRequestIdForTraceSampling = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.displayName = 'proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.prototype.toObject = function(opt_includeInstance) {
  return proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.toObject = function(includeInstance, msg) {
  var f, obj = {
    addressPrefix: jspb.Message.getFieldWithDefault(msg, 1, ""),
    prefixLen: (f = msg.getPrefixLen()) && google_protobuf_wrappers_pb.UInt32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange;
  return proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressPrefix(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.UInt32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.UInt32Value.deserializeBinaryFromReader);
      msg.setPrefixLen(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddressPrefix();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrefixLen();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.UInt32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string address_prefix = 1;
 * @return {string}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.prototype.getAddressPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.prototype.setAddressPrefix = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.UInt32Value prefix_len = 2;
 * @return {?proto.google.protobuf.UInt32Value}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.prototype.getPrefixLen = function() {
  return /** @type{?proto.google.protobuf.UInt32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.UInt32Value, 2));
};


/** @param {?proto.google.protobuf.UInt32Value|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.prototype.setPrefixLen = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.prototype.clearPrefixLen = function() {
  this.setPrefixLen(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.prototype.hasPrefixLen = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.repeatedFields_, null);
};
goog.inherits(proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.displayName = 'proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    unixSockets: (f = msg.getUnixSockets()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    cidrRangesList: jspb.Message.toObjectList(msg.getCidrRangesList(),
    proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig;
  return proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setUnixSockets(value);
      break;
    case 2:
      var value = new proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange;
      reader.readMessage(value,proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.deserializeBinaryFromReader);
      msg.addCidrRanges(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnixSockets();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCidrRangesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.BoolValue unix_sockets = 1;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.prototype.getUnixSockets = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 1));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.prototype.setUnixSockets = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.prototype.clearUnixSockets = function() {
  this.setUnixSockets(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.prototype.hasUnixSockets = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated CidrRange cidr_ranges = 2;
 * @return {!Array<!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange>}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.prototype.getCidrRangesList = function() {
  return /** @type{!Array<!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange, 2));
};


/** @param {!Array<!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange>} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.prototype.setCidrRangesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange=} opt_value
 * @param {number=} opt_index
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.prototype.addCidrRanges = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CidrRange, opt_index);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig.prototype.clearCidrRangesList = function() {
  this.setCidrRangesList([]);
};


/**
 * optional google.protobuf.BoolValue skip_xff_append = 1;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getSkipXffAppend = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 1));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setSkipXffAppend = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearSkipXffAppend = function() {
  this.setSkipXffAppend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasSkipXffAppend = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue via = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getVia = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/** @param {?proto.google.protobuf.StringValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setVia = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearVia = function() {
  this.setVia(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasVia = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.UInt32Value xff_num_trusted_hops = 3;
 * @return {?proto.google.protobuf.UInt32Value}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getXffNumTrustedHops = function() {
  return /** @type{?proto.google.protobuf.UInt32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.UInt32Value, 3));
};


/** @param {?proto.google.protobuf.UInt32Value|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setXffNumTrustedHops = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearXffNumTrustedHops = function() {
  this.setXffNumTrustedHops(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasXffNumTrustedHops = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue use_remote_address = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getUseRemoteAddress = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setUseRemoteAddress = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearUseRemoteAddress = function() {
  this.setUseRemoteAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasUseRemoteAddress = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue generate_request_id = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getGenerateRequestId = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setGenerateRequestId = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearGenerateRequestId = function() {
  this.setGenerateRequestId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasGenerateRequestId = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.BoolValue proxy_100_continue = 6;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getProxy100Continue = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 6));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setProxy100Continue = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearProxy100Continue = function() {
  this.setProxy100Continue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasProxy100Continue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Duration stream_idle_timeout = 7;
 * @return {?proto.google.protobuf.Duration}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getStreamIdleTimeout = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 7));
};


/** @param {?proto.google.protobuf.Duration|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setStreamIdleTimeout = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearStreamIdleTimeout = function() {
  this.setStreamIdleTimeout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasStreamIdleTimeout = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Duration idle_timeout = 8;
 * @return {?proto.google.protobuf.Duration}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getIdleTimeout = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 8));
};


/** @param {?proto.google.protobuf.Duration|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setIdleTimeout = function(value) {
  jspb.Message.setWrapperField(this, 8, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearIdleTimeout = function() {
  this.setIdleTimeout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasIdleTimeout = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.UInt32Value max_request_headers_kb = 9;
 * @return {?proto.google.protobuf.UInt32Value}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getMaxRequestHeadersKb = function() {
  return /** @type{?proto.google.protobuf.UInt32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.UInt32Value, 9));
};


/** @param {?proto.google.protobuf.UInt32Value|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setMaxRequestHeadersKb = function(value) {
  jspb.Message.setWrapperField(this, 9, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearMaxRequestHeadersKb = function() {
  this.setMaxRequestHeadersKb(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasMaxRequestHeadersKb = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Duration request_timeout = 10;
 * @return {?proto.google.protobuf.Duration}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getRequestTimeout = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 10));
};


/** @param {?proto.google.protobuf.Duration|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setRequestTimeout = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearRequestTimeout = function() {
  this.setRequestTimeout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasRequestTimeout = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Duration request_headers_timeout = 11;
 * @return {?proto.google.protobuf.Duration}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getRequestHeadersTimeout = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 11));
};


/** @param {?proto.google.protobuf.Duration|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setRequestHeadersTimeout = function(value) {
  jspb.Message.setWrapperField(this, 11, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearRequestHeadersTimeout = function() {
  this.setRequestHeadersTimeout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasRequestHeadersTimeout = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Duration drain_timeout = 12;
 * @return {?proto.google.protobuf.Duration}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getDrainTimeout = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 12));
};


/** @param {?proto.google.protobuf.Duration|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setDrainTimeout = function(value) {
  jspb.Message.setWrapperField(this, 12, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearDrainTimeout = function() {
  this.setDrainTimeout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasDrainTimeout = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Duration delayed_close_timeout = 13;
 * @return {?proto.google.protobuf.Duration}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getDelayedCloseTimeout = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 13));
};


/** @param {?proto.google.protobuf.Duration|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setDelayedCloseTimeout = function(value) {
  jspb.Message.setWrapperField(this, 13, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearDelayedCloseTimeout = function() {
  this.setDelayedCloseTimeout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasDelayedCloseTimeout = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.StringValue server_name = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getServerName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/** @param {?proto.google.protobuf.StringValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setServerName = function(value) {
  jspb.Message.setWrapperField(this, 14, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearServerName = function() {
  this.setServerName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasServerName = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.BoolValue strip_any_host_port = 36;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getStripAnyHostPort = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 36));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setStripAnyHostPort = function(value) {
  jspb.Message.setWrapperField(this, 36, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearStripAnyHostPort = function() {
  this.setStripAnyHostPort(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasStripAnyHostPort = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional google.protobuf.BoolValue accept_http_10 = 15;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getAcceptHttp10 = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 15));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setAcceptHttp10 = function(value) {
  jspb.Message.setWrapperField(this, 15, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearAcceptHttp10 = function() {
  this.setAcceptHttp10(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasAcceptHttp10 = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.StringValue default_host_for_http_10 = 16;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getDefaultHostForHttp10 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 16));
};


/** @param {?proto.google.protobuf.StringValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setDefaultHostForHttp10 = function(value) {
  jspb.Message.setWrapperField(this, 16, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearDefaultHostForHttp10 = function() {
  this.setDefaultHostForHttp10(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasDefaultHostForHttp10 = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.BoolValue allow_chunked_length = 34;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getAllowChunkedLength = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 34));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setAllowChunkedLength = function(value) {
  jspb.Message.setWrapperField(this, 34, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearAllowChunkedLength = function() {
  this.setAllowChunkedLength(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasAllowChunkedLength = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional google.protobuf.BoolValue enable_trailers = 35;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getEnableTrailers = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 35));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setEnableTrailers = function(value) {
  jspb.Message.setWrapperField(this, 35, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearEnableTrailers = function() {
  this.setEnableTrailers(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasEnableTrailers = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional google.protobuf.BoolValue proper_case_header_key_format = 22;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getProperCaseHeaderKeyFormat = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 22));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setProperCaseHeaderKeyFormat = function(value) {
  jspb.Message.setOneofWrapperField(this, 22, proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.oneofGroups_[0], value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearProperCaseHeaderKeyFormat = function() {
  this.setProperCaseHeaderKeyFormat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasProperCaseHeaderKeyFormat = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.BoolValue preserve_case_header_key_format = 31;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getPreserveCaseHeaderKeyFormat = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 31));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setPreserveCaseHeaderKeyFormat = function(value) {
  jspb.Message.setOneofWrapperField(this, 31, proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.oneofGroups_[0], value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearPreserveCaseHeaderKeyFormat = function() {
  this.setPreserveCaseHeaderKeyFormat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasPreserveCaseHeaderKeyFormat = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional tracing.options.gloo.solo.io.ListenerTracingSettings tracing = 17;
 * @return {?proto.tracing.options.gloo.solo.io.ListenerTracingSettings}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getTracing = function() {
  return /** @type{?proto.tracing.options.gloo.solo.io.ListenerTracingSettings} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_tracing_tracing_pb.ListenerTracingSettings, 17));
};


/** @param {?proto.tracing.options.gloo.solo.io.ListenerTracingSettings|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setTracing = function(value) {
  jspb.Message.setWrapperField(this, 17, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearTracing = function() {
  this.setTracing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasTracing = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional ForwardClientCertDetails forward_client_cert_details = 18;
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.ForwardClientCertDetails}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getForwardClientCertDetails = function() {
  return /** @type {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.ForwardClientCertDetails} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.ForwardClientCertDetails} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setForwardClientCertDetails = function(value) {
  jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * optional SetCurrentClientCertDetails set_current_client_cert_details = 19;
 * @return {?proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getSetCurrentClientCertDetails = function() {
  return /** @type{?proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails} */ (
    jspb.Message.getWrapperField(this, proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails, 19));
};


/** @param {?proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.SetCurrentClientCertDetails|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setSetCurrentClientCertDetails = function(value) {
  jspb.Message.setWrapperField(this, 19, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearSetCurrentClientCertDetails = function() {
  this.setSetCurrentClientCertDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasSetCurrentClientCertDetails = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.BoolValue preserve_external_request_id = 20;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getPreserveExternalRequestId = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 20));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setPreserveExternalRequestId = function(value) {
  jspb.Message.setWrapperField(this, 20, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearPreserveExternalRequestId = function() {
  this.setPreserveExternalRequestId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasPreserveExternalRequestId = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * repeated protocol_upgrade.options.gloo.solo.io.ProtocolUpgradeConfig upgrades = 21;
 * @return {!Array<!proto.protocol_upgrade.options.gloo.solo.io.ProtocolUpgradeConfig>}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getUpgradesList = function() {
  return /** @type{!Array<!proto.protocol_upgrade.options.gloo.solo.io.ProtocolUpgradeConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_protocol_upgrade_protocol_upgrade_pb.ProtocolUpgradeConfig, 21));
};


/** @param {!Array<!proto.protocol_upgrade.options.gloo.solo.io.ProtocolUpgradeConfig>} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setUpgradesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.protocol_upgrade.options.gloo.solo.io.ProtocolUpgradeConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.protocol_upgrade.options.gloo.solo.io.ProtocolUpgradeConfig}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.addUpgrades = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.protocol_upgrade.options.gloo.solo.io.ProtocolUpgradeConfig, opt_index);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearUpgradesList = function() {
  this.setUpgradesList([]);
};


/**
 * optional google.protobuf.Duration max_connection_duration = 23;
 * @return {?proto.google.protobuf.Duration}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getMaxConnectionDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 23));
};


/** @param {?proto.google.protobuf.Duration|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setMaxConnectionDuration = function(value) {
  jspb.Message.setWrapperField(this, 23, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearMaxConnectionDuration = function() {
  this.setMaxConnectionDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasMaxConnectionDuration = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.Duration max_stream_duration = 24;
 * @return {?proto.google.protobuf.Duration}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getMaxStreamDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 24));
};


/** @param {?proto.google.protobuf.Duration|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setMaxStreamDuration = function(value) {
  jspb.Message.setWrapperField(this, 24, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearMaxStreamDuration = function() {
  this.setMaxStreamDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasMaxStreamDuration = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.UInt32Value max_headers_count = 27;
 * @return {?proto.google.protobuf.UInt32Value}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getMaxHeadersCount = function() {
  return /** @type{?proto.google.protobuf.UInt32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.UInt32Value, 27));
};


/** @param {?proto.google.protobuf.UInt32Value|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setMaxHeadersCount = function(value) {
  jspb.Message.setWrapperField(this, 27, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearMaxHeadersCount = function() {
  this.setMaxHeadersCount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasMaxHeadersCount = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional HeadersWithUnderscoreAction headers_with_underscores_action = 32;
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.HeadersWithUnderscoreAction}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getHeadersWithUnderscoresAction = function() {
  return /** @type {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.HeadersWithUnderscoreAction} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/** @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.HeadersWithUnderscoreAction} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setHeadersWithUnderscoresAction = function(value) {
  jspb.Message.setProto3EnumField(this, 32, value);
};


/**
 * optional google.protobuf.UInt32Value max_requests_per_connection = 33;
 * @return {?proto.google.protobuf.UInt32Value}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getMaxRequestsPerConnection = function() {
  return /** @type{?proto.google.protobuf.UInt32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.UInt32Value, 33));
};


/** @param {?proto.google.protobuf.UInt32Value|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setMaxRequestsPerConnection = function(value) {
  jspb.Message.setWrapperField(this, 33, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearMaxRequestsPerConnection = function() {
  this.setMaxRequestsPerConnection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasMaxRequestsPerConnection = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional ServerHeaderTransformation server_header_transformation = 25;
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.ServerHeaderTransformation}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getServerHeaderTransformation = function() {
  return /** @type {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.ServerHeaderTransformation} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/** @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.ServerHeaderTransformation} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setServerHeaderTransformation = function(value) {
  jspb.Message.setProto3EnumField(this, 25, value);
};


/**
 * optional PathWithEscapedSlashesAction path_with_escaped_slashes_action = 26;
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.PathWithEscapedSlashesAction}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getPathWithEscapedSlashesAction = function() {
  return /** @type {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.PathWithEscapedSlashesAction} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/** @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.PathWithEscapedSlashesAction} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setPathWithEscapedSlashesAction = function(value) {
  jspb.Message.setProto3EnumField(this, 26, value);
};


/**
 * optional CodecType codec_type = 28;
 * @return {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CodecType}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getCodecType = function() {
  return /** @type {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CodecType} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/** @param {!proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.CodecType} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setCodecType = function(value) {
  jspb.Message.setProto3EnumField(this, 28, value);
};


/**
 * optional google.protobuf.BoolValue merge_slashes = 29;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getMergeSlashes = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 29));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setMergeSlashes = function(value) {
  jspb.Message.setWrapperField(this, 29, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearMergeSlashes = function() {
  this.setMergeSlashes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasMergeSlashes = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional google.protobuf.BoolValue normalize_path = 30;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getNormalizePath = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 30));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setNormalizePath = function(value) {
  jspb.Message.setWrapperField(this, 30, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearNormalizePath = function() {
  this.setNormalizePath(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasNormalizePath = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional UuidRequestIdConfigSettings uuid_request_id_config = 37;
 * @return {?proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getUuidRequestIdConfig = function() {
  return /** @type{?proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings} */ (
    jspb.Message.getWrapperField(this, proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings, 37));
};


/** @param {?proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.UuidRequestIdConfigSettings|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setUuidRequestIdConfig = function(value) {
  jspb.Message.setWrapperField(this, 37, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearUuidRequestIdConfig = function() {
  this.setUuidRequestIdConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasUuidRequestIdConfig = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional protocol.options.gloo.solo.io.Http2ProtocolOptions http2_protocol_options = 39;
 * @return {?proto.protocol.options.gloo.solo.io.Http2ProtocolOptions}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getHttp2ProtocolOptions = function() {
  return /** @type{?proto.protocol.options.gloo.solo.io.Http2ProtocolOptions} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_protocol_protocol_pb.Http2ProtocolOptions, 39));
};


/** @param {?proto.protocol.options.gloo.solo.io.Http2ProtocolOptions|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setHttp2ProtocolOptions = function(value) {
  jspb.Message.setWrapperField(this, 39, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearHttp2ProtocolOptions = function() {
  this.setHttp2ProtocolOptions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasHttp2ProtocolOptions = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional InternalAddressConfig internal_address_config = 38;
 * @return {?proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getInternalAddressConfig = function() {
  return /** @type{?proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig} */ (
    jspb.Message.getWrapperField(this, proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig, 38));
};


/** @param {?proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.InternalAddressConfig|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setInternalAddressConfig = function(value) {
  jspb.Message.setWrapperField(this, 38, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearInternalAddressConfig = function() {
  this.setInternalAddressConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasInternalAddressConfig = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional google.protobuf.BoolValue append_x_forwarded_port = 40;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.getAppendXForwardedPort = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 40));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.setAppendXForwardedPort = function(value) {
  jspb.Message.setWrapperField(this, 40, value);
};


proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.clearAppendXForwardedPort = function() {
  this.setAppendXForwardedPort(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.hcm.options.gloo.solo.io.HttpConnectionManagerSettings.prototype.hasAppendXForwardedPort = function() {
  return jspb.Message.getField(this, 40) != null;
};


goog.object.extend(exports, proto.hcm.options.gloo.solo.io);
